import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ISolarAddress } from 'app/interfaces/ISolarAddress';
import { ISolarObjects } from 'app/interfaces/ISolarObjects';
import { KeycloakService } from 'app/login/keycloak.service';
import { EventsService } from 'app/_services/events.service';
import { GlobalsService } from 'app/_services/globals.service';
import { LayersService } from 'app/_services/layers.service';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { SolarReceiverService } from 'app/_services/solar-receiver.service';
import { TabledataService } from 'app/_services/tabledata.service';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-solar-receiver',
    templateUrl: './solar-receiver.component.html',
    styleUrls: ['./solar-receiver.component.css'],
    providers: [SolarReceiverService],
    standalone: false
})
export class SolarReceiverComponent implements OnInit {
  @Output() onCloseEmmiter: EventEmitter<any> = new EventEmitter<any>()

  solarReceiverType: SelectItem[] = [{ label: 'ogrevanje sanitarne vode', value: 1 }, { label: 'ogrevanje prostorov', value: 2 }];
  selectedSolarReceiverType: any = 1
  waterHeating: SelectItem[] = [{ label: 'Najdi po naslovu', value: 1 }, { label: 'Najdi ustrezne objekte', value: 2 }];
  waterHeatingSelected: any = 1;
  rabeobjekta: SelectItem[] = [];
  selectedraba: any = -1;
  ssLpeKwhkWp: SelectItem[] = [{ label: 'Letna proizvodnja električne energije [kWh]', value: 1 }, { label: 'Nazivna moč sončne elektrarne [kWp]', value: 2 }];
  ssLpeKwhkWpSelected: any = 1;
  solarRoofType: SelectItem[] = [{ label: 'vakuumski', value: 1 }, { label: 'ploščati', value: 2 }];
  solarRoofTypeSelected: any = 1;
  obmidsparameter: number;
  midparameter: number;

  powerPlantRoofObjectSrchForm = this.formBuilder.group({
    raba: -1,
    lastnik_drzava: false,
    lastnik_obcina: false,
    lastnik_pravna_os: false,
    lastnik_fizicna_os: false,
    brez_kult_ded: true,
    coveredSTV: 75,
    roof_type: 1,
    tlp: 1,
    lp: 1000,
    ravna_s: false,
    max_rs_obj: 0,
    l_ob_str: 30,
    l_ob_obj: 30
  });

  constructor(
    private formBuilder: FormBuilder,
    private tService: TabledataService,
    private gs: GlobalsService,
    private layersService: LayersService,
    private eventService: EventsService,
    private solarReceiverService: SolarReceiverService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.rabeobjekta.push({ label: 'Vsi', value: 1 });
    this.tService.getData(this.gs.getRestUrl() + "/api/fotovoltaika/sifnamobj", true).subscribe((r: any) => r.flatMap(i => {
      this.rabeobjekta.push({ label: i.opis, value: i.sifra });
    }));
    this.layersService.subscribeLayersGroupLoadListener().subscribe(
      data => {
        if (data.ob_mid !== undefined) {
          // console.log("load layer group ob mid:"+data.ob_mid);
          console.log("pc!!", data);

          this.obmidsparameter = data.ob_mids;
          this.midparameter = data.ob_mid;
        }
        else {
          console.log("load layer group error: data undefined ");
        }
      },
      err => { console.log(err) }

    );
  }


  doSelectRecieverType(event): void {

  }
  doSelLpeType(e: any) {
  }
  doSelRoofType(e: any) {
  }
  onSearchSelect(e: any) {
    if(e){
      e[0]._hs;
      e[0]._hs_mid;
      e[0]._na_mid;
      this.midparameter = e[0]._ob_mid;
      e[0]._obcina;
      e[0]._sta_sid;
      e[0].naslov;
    }

    console.warn("SEARCH SELECT", e[0])
  }

  onAddressSubmit() {
    const obj: ISolarAddress = {
      analysisTypeId: this.selectedSolarReceiverType,
      sollarCollectorType: this.solarRoofTypeSelected,
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter.toString(),
      hs_mid: 13153027
    }
    //http://192.168.0.62:8081/EnrovidualRest/api/planiranjeSoncniSprejemniki/getSolarCollectorBuildingByAddress
    console.log(obj)
    this.solarReceiverService.postSolarReceiverAddressResults(obj).subscribe(
      {
        next: response => {
          console.warn("RESPONSE", response)
          this.messageService.add({ severity: 'info', summary: 'Obvestilo', detail: response.msg });
          this.showData(response)
          this.onCloseEmmiter.emit({ open: false, msg: { severity: 'info', summary: 'Obvestilo', detail: response.msg } });
        },
        error: err => {
          console.error("Error", err)
          this.onCloseEmmiter.emit({ open: true, msg: { severity: 'error', summary: `Error`, detail: JSON.parse(err._body).msg } });
        }
      }
    )
  }

  onFindSelectedClicked(event) {
    this.waterHeatingSelected = event.value;
    console.warn(this.waterHeatingSelected)
  }

  onSubmitPPORS(): void {
    const obj: ISolarObjects = {
      analysisTypeId: this.selectedSolarReceiverType,
      buildingPrimaryUseCode: 5023,
      ownerIsState: this.powerPlantRoofObjectSrchForm.value.lastnik_drzava,
      ownerIsMunicipality: this.powerPlantRoofObjectSrchForm.value.lastnik_obcina,
      ownerIsLegalPerson: this.powerPlantRoofObjectSrchForm.value.lastnik_pravna_os,
      ownerIsNaturalPerson: this.powerPlantRoofObjectSrchForm.value.lastnik_fizicna_os,
      buildingIsNotProtectedCulturalHeritage: this.powerPlantRoofObjectSrchForm.value.brez_kult_ded,
      maxBuildingsInResultSet: this.powerPlantRoofObjectSrchForm.value.max_rs_obj,
      shareOfHeatUse4Heating: this.powerPlantRoofObjectSrchForm.value.coveredSTV,
      yearsFromLastRoofRenewal: this.powerPlantRoofObjectSrchForm.value.l_ob_obj,
      buildingAge: this.powerPlantRoofObjectSrchForm.value.l_ob_str,
      sollarCollectorType: this.solarRoofTypeSelected,
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter.toString(),
    }
    //http://192.168.0.62:8081/EnrovidualRest/api/planiranjeSoncniSprejemniki/getSolarCollectorBuildingsByParams
    console.warn(obj)
    this.solarReceiverService.postSolarReceiverObjectsResults(obj).subscribe(
      {
        next: response => {
          console.warn("RESPONSE", response)
          this.messageService.add({ severity: 'info', summary: 'Obvestilo', detail: response.msg });
          this.showData(response)
          this.onCloseEmmiter.emit({ open: false, msg: { severity: 'info', summary: 'Obvestilo', detail: response.msg } });
        },
        error: err => {
          console.error("Error", err)
          this.onCloseEmmiter.emit({ open: true, msg: { severity: 'error', summary: `Error`, detail: JSON.parse(err._body).msg } });
        }
      }
    )
  }
  private showData(r: any): void {

    if (r.status === true) {
      let tabels = [];
      if (r.dependendLayerIds) {
        tabels = tabels.concat(r.dependendLayerIds);
      }
      tabels.push(r.webappLayerId);


      tabels.forEach(id => {

        let node = this.layersService.findNodeById(id);
        if (node !== null) {
          this.eventService.sendTreeNodeOnOffEvt({ id: id, ison: true });
          node.data.showtable = true;
          node.data.tabledataloaded = false;
          this.tService.setRequestTableData(node);
          var s1 = this.tService.subscribeDataListener().subscribe(data => {
            s1.unsubscribe();
            this.tService.setShowTable(node.data.id, true, node.label, node);
          });
          //console.log("find node in tree",node);
        }
      });
    }
  }
}



